import { frontendURL } from '../../../helper/URLHelper';
import CrmPage from './CrmPage.vue';

const crmRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/crm'),
      name: 'crm_index',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: CrmPage,
    },
  ],
};

export default crmRoutes;
